import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = { class: "step-header" }
const _hoisted_4 = {
  key: 0,
  class: "step-summary"
}
const _hoisted_5 = {
  key: 0,
  class: "step-body"
}
const _hoisted_6 = { class: "step-header" }
const _hoisted_7 = { class: "step-label" }
const _hoisted_8 = {
  key: 0,
  class: "step-summary"
}
const _hoisted_9 = {
  key: 0,
  class: "step-body"
}
const _hoisted_10 = {
  key: 0,
  class: "loading-row"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "content-card"
}
const _hoisted_15 = { class: "content-card-header" }
const _hoisted_16 = { class: "card-badge" }
const _hoisted_17 = { class: "content-card-body" }
const _hoisted_18 = { class: "input-row" }
const _hoisted_19 = { class: "field-group" }
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "table-wrap"
}
const _hoisted_23 = { class: "data-table" }
const _hoisted_24 = { class: "col-num muted" }
const _hoisted_25 = { class: "currency" }
const _hoisted_26 = { class: "col-action" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "table-footer" }
const _hoisted_29 = { class: "table-summary" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "btn-spinner"
}
const _hoisted_33 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_34 = {
  key: 2,
  class: "results-card"
}
const _hoisted_35 = { class: "results-header" }
const _hoisted_36 = { class: "results-count" }
const _hoisted_37 = ["href"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "result-group-amount" }
const _hoisted_40 = { class: "result-group-count" }
const _hoisted_41 = {
  key: 0,
  class: "result-group-body"
}
const _hoisted_42 = { class: "data-table" }
const _hoisted_43 = { class: "col-num muted" }
const _hoisted_44 = { class: "user-id" }
const _hoisted_45 = { class: "ticket" }
const _hoisted_46 = { class: "col-action" }
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 1,
  class: "content-card"
}
const _hoisted_49 = { class: "content-card-header" }
const _hoisted_50 = { class: "card-badge" }
const _hoisted_51 = { class: "content-card-body" }
const _hoisted_52 = { class: "inner-step-header" }
const _hoisted_53 = {
  key: 0,
  class: "step-summary"
}
const _hoisted_54 = {
  key: 0,
  class: "inner-step-body"
}
const _hoisted_55 = {
  key: 0,
  class: "loading-row"
}
const _hoisted_56 = ["value"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "input-row" }
const _hoisted_59 = { class: "field-group" }
const _hoisted_60 = { class: "field-group" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "table-wrap"
}
const _hoisted_63 = { class: "data-table" }
const _hoisted_64 = { class: "col-num muted" }
const _hoisted_65 = { class: "currency" }
const _hoisted_66 = { class: "col-action" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "table-footer" }
const _hoisted_69 = { class: "table-summary" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = {
  key: 1,
  class: "btn-spinner"
}
const _hoisted_73 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_74 = {
  key: 2,
  class: "results-card",
  style: {"margin-top":"1.25rem"}
}
const _hoisted_75 = { class: "results-header" }
const _hoisted_76 = {
  class: "results-count",
  style: {"margin-right":"auto"}
}
const _hoisted_77 = ["href"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "result-group-amount" }
const _hoisted_80 = { class: "result-group-count" }
const _hoisted_81 = {
  key: 0,
  class: "result-group-body"
}
const _hoisted_82 = { class: "data-table" }
const _hoisted_83 = { class: "col-num muted" }
const _hoisted_84 = { class: "user-id" }
const _hoisted_85 = { class: "col-action" }
const _hoisted_86 = ["href"]
const _hoisted_87 = {
  key: 1,
  class: "empty-hint",
  style: {"margin-top":"0.75rem"}
}
const _hoisted_88 = {
  key: 2,
  class: "content-card"
}
const _hoisted_89 = { class: "content-card-header" }
const _hoisted_90 = { class: "card-badge" }
const _hoisted_91 = { class: "content-card-body" }
const _hoisted_92 = { class: "input-row" }
const _hoisted_93 = { class: "field-group" }
const _hoisted_94 = ["value"]
const _hoisted_95 = { class: "field-group" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  key: 1,
  class: "btn-spinner"
}
const _hoisted_99 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_100 = {
  key: 1,
  class: "results-card"
}
const _hoisted_101 = { class: "results-header" }
const _hoisted_102 = {
  class: "results-count",
  style: {"margin-right":"auto"}
}
const _hoisted_103 = ["href"]
const _hoisted_104 = { class: "ae-results-body" }
const _hoisted_105 = { class: "data-table" }
const _hoisted_106 = { class: "col-num muted" }
const _hoisted_107 = { class: "user-id" }
const _hoisted_108 = { class: "col-action" }
const _hoisted_109 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "page-header" }, [
        _createElementVNode("h1", { class: "page-title" }, "Credit & Entries"),
        _createElementVNode("p", { class: "page-subtitle" }, "Manage credit winners, entry winners and Rewards Pass entries for competitions.")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["step-card", { 'step-card--compact': _ctx.selectedOption }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "step-badge" }, "1", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "step-label" }, "Select an action", -1)),
          (_ctx.selectedOption)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.optionLabel), 1))
            : _createCommentVNode("", true),
          (_ctx.selectedOption)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "step-change",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetOption && _ctx.resetOption(...args)))
              }, "Change"))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.selectedOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives(_createElementVNode("select", {
                class: "styled-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOption) = $event))
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("option", {
                  disabled: "",
                  value: null
                }, "Choose an option...", -1),
                _createElementVNode("option", { value: "credit-winners" }, "Select Credit Winners", -1),
                _createElementVNode("option", { value: "entry-winners" }, "Select Entry Winners", -1),
                _createElementVNode("option", { value: "auto-entries" }, "Add Rewards Pass Entry", -1)
              ]), 512), [
                [_vModelSelect, _ctx.selectedOption]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.selectedOption)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["step-card", { 'step-card--compact': _ctx.selectedCompetitionId }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "step-badge" }, "2", -1)),
              _createElementVNode("span", _hoisted_7, " Select a " + _toDisplayString(_ctx.selectedOption === 'auto-entries' ? 'live' : 'recently ended') + " competition ", 1),
              (_ctx.selectedCompetitionId)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.competitionLabel), 1))
                : _createCommentVNode("", true),
              (_ctx.selectedCompetitionId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "step-change",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetCompetition && _ctx.resetCompetition(...args)))
                  }, "Change"))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.selectedCompetitionId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.loadingCompetitions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[21] || (_cache[21] = [
                        _createElementVNode("span", { class: "loading-spinner" }, null, -1),
                        _createTextVNode(" Loading competitions... ")
                      ])))
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        class: "styled-select",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCompetitionId) = $event))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("option", {
                          disabled: "",
                          value: null
                        }, "Choose a competition...", -1)),
                        (_ctx.selectedOption !== 'auto-entries')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.endedCompetitions, (comp) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: comp.competitionId,
                                value: comp.competitionId
                              }, " WSP" + _toDisplayString(comp.competitionId) + " — " + _toDisplayString(comp.competitionName), 9, _hoisted_11))
                            }), 128))
                          : _createCommentVNode("", true),
                        (_ctx.selectedOption === 'auto-entries')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeCompetitions, (comp) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: comp.competitionId,
                                value: comp.competitionId
                              }, " WSP" + _toDisplayString(comp.competitionId) + " — " + _toDisplayString(comp.competitionTitle), 9, _hoisted_12))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 512)), [
                        [_vModelSelect, _ctx.selectedCompetitionId]
                      ])
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.selectedCompetitionId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.selectedOption === 'credit-winners')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "card-title" }, "Credit Winners", -1)),
                    _createElementVNode("span", _hoisted_16, "WSP" + _toDisplayString(_ctx.selectedCompetitionId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          class: "field-label",
                          for: "creditAmount"
                        }, "Credit Amount (£)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "creditAmount",
                          class: "field-input",
                          type: "number",
                          min: "1",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newCreditAmount) = $event)),
                          placeholder: "e.g. 50"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.newCreditAmount,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                          class: "field-label",
                          for: "numberOfUsers"
                        }, "Number of Users", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "numberOfUsers",
                          class: "field-input",
                          type: "number",
                          min: "1",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newNumberOfUsers) = $event)),
                          placeholder: "e.g. 3"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.newNumberOfUsers,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn-add",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addCreditEntry && _ctx.addCreditEntry(...args))),
                        disabled: !_ctx.newCreditAmount || !_ctx.newNumberOfUsers
                      }, " + Add to List ", 8, _hoisted_21)
                    ]),
                    (_ctx.creditEntries.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("table", _hoisted_23, [
                            _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "col-num" }, "#"),
                                _createElementVNode("th", null, "Credit Amount"),
                                _createElementVNode("th", null, "Number of Users"),
                                _createElementVNode("th", { class: "col-action" })
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditEntries, (entry, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", _hoisted_24, _toDisplayString(index + 1), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_25, "£" + _toDisplayString(entry.creditAmount.toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(entry.numberOfUsers), 1),
                                  _createElementVNode("td", _hoisted_26, [
                                    _createElementVNode("button", {
                                      class: "btn-remove",
                                      onClick: ($event: any) => (_ctx.removeCreditEntry(index)),
                                      title: "Remove"
                                    }, "✕", 8, _hoisted_27)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.creditEntries.length) + " " + _toDisplayString(_ctx.creditEntries.length === 1 ? 'entry' : 'entries'), 1),
                            _createElementVNode("button", {
                              class: "btn-primary",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitCreditWinners && _ctx.submitCreditWinners(...args))),
                              disabled: _ctx.isSubmitting
                            }, [
                              (!_ctx.isSubmitting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Add Credit"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_32))
                            ], 8, _hoisted_30)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.creditEntries.length && !_ctx.creditWinnerResults.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Use the form above to add credit entries to the list."))
                      : _createCommentVNode("", true),
                    (_ctx.creditWinnerResults.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "results-title" }, "Selected Winners", -1)),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.creditWinnerResults.length) + " user" + _toDisplayString(_ctx.creditWinnerResults.length === 1 ? '' : 's'), 1),
                            _createElementVNode("a", {
                              href: _ctx.hangfireUrl,
                              target: "_blank",
                              class: "hangfire-link hangfire-link--inline"
                            }, "Hangfire Dashboard ↗", 8, _hoisted_37)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedResults, (group) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: group.creditAmount,
                              class: "result-group"
                            }, [
                              _createElementVNode("button", {
                                class: "result-group-toggle",
                                onClick: ($event: any) => (_ctx.toggleGroup(group.creditAmount))
                              }, [
                                _createElementVNode("span", _hoisted_39, "£" + _toDisplayString(group.creditAmount.toLocaleString()) + " credit", 1),
                                _createElementVNode("span", _hoisted_40, _toDisplayString(group.winners.length) + " user" + _toDisplayString(group.winners.length === 1 ? '' : 's'), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["result-group-chevron", { 'is-open': _ctx.isGroupOpen(group.creditAmount) }])
                                }, "⌄", 2)
                              ], 8, _hoisted_38),
                              (_ctx.isGroupOpen(group.creditAmount))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createElementVNode("table", _hoisted_42, [
                                      _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", { class: "col-num" }, "#"),
                                          _createElementVNode("th", null, "User ID"),
                                          _createElementVNode("th", null, "Ticket Number"),
                                          _createElementVNode("th", { class: "col-action" })
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.winners, (winner, index) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                            _createElementVNode("td", _hoisted_43, _toDisplayString(index + 1), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", _hoisted_44, _toDisplayString(winner.userId), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", _hoisted_45, _toDisplayString(winner.ticketNumber), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_46, [
                                              _createElementVNode("a", {
                                                href: `/users/${winner.userId}`,
                                                target: "_blank",
                                                class: "btn-view-user",
                                                title: "View user"
                                              }, "↗", 8, _hoisted_47)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedOption === 'entry-winners')
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "card-title" }, "Entry Winners", -1)),
                    _createElementVNode("span", _hoisted_50, "WSP" + _toDisplayString(_ctx.selectedCompetitionId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["inner-step", { 'inner-step--compact': _ctx.targetCompetitionId }])
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "step-badge step-badge--sm" }, "3", -1)),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "step-label" }, "Select the live competition to add entries to", -1)),
                        (_ctx.targetCompetitionId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.targetCompetitionLabel), 1))
                          : _createCommentVNode("", true),
                        (_ctx.targetCompetitionId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "step-change",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.targetCompetitionId = null))
                            }, "Change"))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.targetCompetitionId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            (_ctx.loadingTargetCompetitions)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, _cache[32] || (_cache[32] = [
                                  _createElementVNode("span", { class: "loading-spinner" }, null, -1),
                                  _createTextVNode(" Loading live competitions... ")
                                ])))
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 1,
                                  class: "styled-select",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.targetCompetitionId) = $event))
                                }, [
                                  _cache[33] || (_cache[33] = _createElementVNode("option", {
                                    disabled: "",
                                    value: null
                                  }, "Choose a live competition...", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetActiveCompetitions, (comp) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: comp.competitionId,
                                      value: comp.competitionId
                                    }, " WSP" + _toDisplayString(comp.competitionId) + " — " + _toDisplayString(comp.competitionTitle), 9, _hoisted_56))
                                  }), 128))
                                ], 512)), [
                                  [_vModelSelect, _ctx.targetCompetitionId]
                                ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.targetCompetitionId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _cache[34] || (_cache[34] = _createElementVNode("label", {
                                class: "field-label",
                                for: "entryCount"
                              }, "Number of Entries", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "entryCount",
                                class: "field-input",
                                type: "number",
                                min: "1",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newEntryCount) = $event)),
                                placeholder: "e.g. 5"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.newEntryCount,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _cache[35] || (_cache[35] = _createElementVNode("label", {
                                class: "field-label",
                                for: "entryUsers"
                              }, "Number of Users", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "entryUsers",
                                class: "field-input",
                                type: "number",
                                min: "1",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newEntryUsers) = $event)),
                                placeholder: "e.g. 3"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.newEntryUsers,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "btn-add",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addEntryWinnerEntry && _ctx.addEntryWinnerEntry(...args))),
                              disabled: !_ctx.newEntryCount || !_ctx.newEntryUsers
                            }, " + Add to List ", 8, _hoisted_61)
                          ]),
                          (_ctx.entryWinnerEntries.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("table", _hoisted_63, [
                                  _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", { class: "col-num" }, "#"),
                                      _createElementVNode("th", null, "Number of Entries"),
                                      _createElementVNode("th", null, "Number of Users"),
                                      _createElementVNode("th", { class: "col-action" })
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryWinnerEntries, (entry, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", _hoisted_64, _toDisplayString(index + 1), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_65, _toDisplayString(entry.numberOfEntries), 1)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(entry.numberOfUsers), 1),
                                        _createElementVNode("td", _hoisted_66, [
                                          _createElementVNode("button", {
                                            class: "btn-remove",
                                            onClick: ($event: any) => (_ctx.removeEntryWinnerEntry(index)),
                                            title: "Remove"
                                          }, "✕", 8, _hoisted_67)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.entryWinnerEntries.length) + " " + _toDisplayString(_ctx.entryWinnerEntries.length === 1 ? 'entry' : 'entries'), 1),
                                  _createElementVNode("button", {
                                    class: "btn-primary",
                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submitEntryWinners && _ctx.submitEntryWinners(...args))),
                                    disabled: _ctx.isSubmittingEntryWinners
                                  }, [
                                    (!_ctx.isSubmittingEntryWinners)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, "Add Entries"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_72))
                                  ], 8, _hoisted_70)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.entryWinnerEntries.length && !_ctx.entryWinnerResults.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_73, "Use the form above to add entry winner rows."))
                            : _createCommentVNode("", true),
                          (_ctx.entryWinnerResults.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _cache[37] || (_cache[37] = _createElementVNode("span", { class: "results-title" }, "Selected Users", -1)),
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.entryWinnerResults.length) + " user" + _toDisplayString(_ctx.entryWinnerResults.length === 1 ? '' : 's'), 1),
                                  _createElementVNode("a", {
                                    href: _ctx.hangfireUrl,
                                    target: "_blank",
                                    class: "hangfire-link hangfire-link--inline"
                                  }, "Hangfire Dashboard ↗", 8, _hoisted_77)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedEntryResults, (group) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: group.numberOfEntries,
                                    class: "result-group"
                                  }, [
                                    _createElementVNode("button", {
                                      class: "result-group-toggle",
                                      onClick: ($event: any) => (_ctx.toggleEntryGroup(group.numberOfEntries))
                                    }, [
                                      _createElementVNode("span", _hoisted_79, _toDisplayString(group.numberOfEntries) + " " + _toDisplayString(group.numberOfEntries === 1 ? 'entry' : 'entries'), 1),
                                      _createElementVNode("span", _hoisted_80, _toDisplayString(group.winners.length) + " user" + _toDisplayString(group.winners.length === 1 ? '' : 's'), 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["result-group-chevron", { 'is-open': _ctx.isEntryGroupOpen(group.numberOfEntries) }])
                                      }, "⌄", 2)
                                    ], 8, _hoisted_78),
                                    (_ctx.isEntryGroupOpen(group.numberOfEntries))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                          _createElementVNode("table", _hoisted_82, [
                                            _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                                              _createElementVNode("tr", null, [
                                                _createElementVNode("th", { class: "col-num" }, "#"),
                                                _createElementVNode("th", null, "User ID"),
                                                _createElementVNode("th", { class: "col-action" })
                                              ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.winners, (winner, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                  _createElementVNode("td", _hoisted_83, _toDisplayString(index + 1), 1),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_84, _toDisplayString(winner.userId), 1)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_85, [
                                                    _createElementVNode("a", {
                                                      href: `/users/${winner.userId}`,
                                                      target: "_blank",
                                                      class: "btn-view-user",
                                                      title: "View user"
                                                    }, "↗", 8, _hoisted_86)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.targetCompetitionId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, "Select a live competition above to continue."))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedOption === 'auto-entries')
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "card-title" }, "Add Rewards Pass Entry", -1)),
                    _createElementVNode("span", _hoisted_90, "WSP" + _toDisplayString(_ctx.selectedCompetitionId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", {
                          class: "field-label",
                          for: "applicationName"
                        }, "Application", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "applicationName",
                          class: "styled-select",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.applicationName) = $event))
                        }, [
                          _cache[40] || (_cache[40] = _createElementVNode("option", {
                            disabled: "",
                            value: null
                          }, "Choose an application...", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationNameOptions, (app) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: app,
                              value: app
                            }, _toDisplayString(app), 9, _hoisted_94))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.applicationName]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", {
                          class: "field-label",
                          for: "entriesPerMember"
                        }, "Entries per Rewards Pass Member", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "entriesPerMember",
                          class: "field-input",
                          type: "number",
                          min: "1",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.entriesPerMember) = $event)),
                          placeholder: "e.g. 5"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.entriesPerMember,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn-add",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.submitAutoEntries && _ctx.submitAutoEntries(...args))),
                        disabled: !_ctx.entriesPerMember || !_ctx.applicationName || _ctx.isSubmittingAutoEntries || _ctx.autoEntryResults.length > 0
                      }, [
                        (!_ctx.isSubmittingAutoEntries)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_97, "Add Entries"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_98))
                      ], 8, _hoisted_96)
                    ]),
                    (!_ctx.autoEntryResults.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_99, "Enter the number of entries and click Add Entries."))
                      : _createCommentVNode("", true),
                    (_ctx.autoEntryResults.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "results-title" }, "Entries Added", -1)),
                            _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.autoEntryResults.length) + " user" + _toDisplayString(_ctx.autoEntryResults.length === 1 ? '' : 's'), 1),
                            _createElementVNode("a", {
                              href: _ctx.hangfireUrl,
                              target: "_blank",
                              class: "hangfire-link hangfire-link--inline"
                            }, "Hangfire Dashboard ↗", 8, _hoisted_103)
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("table", _hoisted_105, [
                              _cache[44] || (_cache[44] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "col-num" }, "#"),
                                  _createElementVNode("th", null, "User ID"),
                                  _createElementVNode("th", { class: "col-action" })
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoEntryResults, (entry, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", _hoisted_106, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", _hoisted_107, _toDisplayString(entry.userId), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_108, [
                                      _createElementVNode("a", {
                                        href: `/users/${entry.userId}`,
                                        target: "_blank",
                                        class: "btn-view-user",
                                        title: "View user"
                                      }, "↗", 8, _hoisted_109)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}